var Handlebars = require("/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"de_pane\">\n  <header class=\"form header\">\n  </header><!-- /header.form -->\n\n  <section class=\"entity-form-container\">\n  </section><!-- /section.entity-form-container -->\n\n  <header class=\"form footer\">\n  </header><!-- /header.form -->\n</div>\n<div class=\"de_sidebar\">\n\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/lib/dataentry/lib/dataentryform/views/templates/bottom_pane.hbs
// module id = 1432
// module chunks = 0